import { Navigate, Route, Routes } from 'react-router-dom';
import { HomePage } from '@/features/home/HomePage';
import { RequestCertificatePage } from '@/features/certificate-request/RequestCertificatePage';
import { MyRequestsPage } from '@/features/my-requests/MyRequestsPage';
import { RequestDetailsPage } from '@/features/my-requests/RequestDetailsPage';
import { ProfilePage } from '@/features/profile/ProfilePage';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/request"
        element={
          <ProtectedRoute>
            <RequestCertificatePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-requests"
        element={
          <ProtectedRoute>
            <MyRequestsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-requests/:id"
        element={
          <ProtectedRoute>
            <RequestDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
